import { Navigate, useParams } from "react-router-dom";

export default function IsolatedCallRedirect() {
  const { token } = useParams<{ token: string }>();

  if (!token) throw new Error("Missing call token");

  return <Navigate to="/isolated-call" replace state={{ callToken: token }} />;
}
